export function booleanMatcherContext(ruleAttr) {
    return function booleanMatcher(runtimeAttr) {
        var booleanMatches = ruleAttr === runtimeAttr;
        return booleanMatches;
    };
}
